
// This is HOC which wraps each screen and sends screen viewed event

import { useCallback, useEffect } from 'react';
import { ThemedView } from '../theme';
import { PrivateStackParamList, PublicStackParamList } from '../navigationApp/types';
import { trackEvent } from '../utils/amplitude';




type ScreenWrapperProps = {
    screenName?: keyof PrivateStackParamList | keyof PublicStackParamList;
    children: React.ReactNode
    additionalProperties?: Record<string, any>
    testID?: string | undefined
}


const ScreenWrapper = ({ screenName, children, additionalProperties , testID }: ScreenWrapperProps) => {

    const eventProperties = { screenName, ...(additionalProperties && { ...additionalProperties }) };
    const eventName = screenName + '_PAGE_VIEWED'

    const triggerEvent = useCallback(() => {
        if (screenName) {
            trackEvent(eventName, eventProperties)
        }
    }, [screenName])

    useEffect(() => {
        triggerEvent()
    }, [triggerEvent])

    return (
        <ThemedView testID={testID} flex={1}>
            {children}
        </ThemedView>
    )
}

export default ScreenWrapper